import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { AccessRole, UserData } from '@deltager/organizers/admin/shared/models/LoginData';
import { UserService } from '@deltager/organizers/admin/core/services/user.service';
import { AppSettingsService } from '../../app-settings/app-settings.service';

@Injectable()
export class UserDataResolver {
  constructor(
    private userService: UserService,
    private router: Router,
    private appSettingsService: AppSettingsService,
  ) {}
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<UserData | null> {
    const userData = await this.userService.getUserData();

    if (userData) {
      const isLimitedAccess = route.data.isLimitedAccess;
      const isCreateEvent = route.data.isCreateEvent;
      const allowRoles = (route.data.allowRoles ?? []) as AccessRole[];

      const isCreateEventsNotAllowed = isCreateEvent && !userData.isLimitedCanCreateEvents();
      const isAccessNotAllowed = isLimitedAccess && this.userService.isLimitedAccessRole(allowRoles);

      if (isCreateEventsNotAllowed || isAccessNotAllowed) {
        await this.router.navigate(['/events']);
        return null;
      }

      return userData;
    } else {
      this.appSettingsService.goToLogin();

      return null;
    }
  }
}
